import React from 'react';

const ReturnPolicyPage = () => {
  return (
    <div className="policy-page container">
      <h1>Refund Policy</h1>

      <p>We value our clients and strive to deliver satisfaction. Our refund policy ensures fairness to both parties.</p>

      <h2>1. Eligibility</h2>
      <p>You may request a refund if:</p>
      <ul>
        <li>We are unable to deliver the promised service</li>
        <li>There was a billing error</li>
        <li>You cancel within 24 hours of purchase and work hasn't started</li>
      </ul>

      <h2>2. Non-Refundable Cases</h2>
      <p>Refunds will not be provided if:</p>
      <ul>
        <li>Work has begun and part of the service has been delivered</li>
        <li>You fail to provide necessary materials or approvals on time</li>
        <li>Dissatisfaction arises from subjective preferences after project completion (e.g. design style)</li>
      </ul>

      <h2>3. How to Request</h2>
      <p>Email us at protechwebexpert@gmail.com with:</p>
      <ul>
        <li>Order details</li>
        <li>Reason for the refund</li>
      </ul>
      <p>Refunds (if approved) will be processed within 7-14 working days to your original payment method.</p>
    </div>
  );
};

export default ReturnPolicyPage; 